module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enrolment"
  }, [_c('el-dialog', {
    attrs: {
      "title": "报名记录",
      "visible": _vm.dialogVisibledelete,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisibledelete = $event
      }
    }
  }, [
    [_c('el-table', {
      attrs: {
        "data": _vm.followList,
        "stripe": "",
        "border": ""
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "ErName",
        "label": "姓名",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ErPhone",
        "label": "电话",
        "align": "center"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "ErTime",
        "align": "center",
        "width": "",
        "label": "报名时间"
      }
    })], 1)], _vm._v(" "), _c('el-pagination', {
      staticStyle: {
        "float": "right",
        "margin-top": "10px"
      },
      attrs: {
        "layout": "prev, pager, next",
        "page-size": 5,
        "current-page": _vm.pageIndexBmrs,
        "total": _vm.totalBmrs
      },
      on: {
        "current-change": _vm.handleCurrentChangeBmrs
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    })
  ], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fb459c02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/addPopNum.vue
// module id = 1759
// module chunks = 3